<template>
  <div>
    <div class="column items-center header">
      <combined-logo/>
    </div>
    <div>
      <fund-approved v-if="this.isApproved" />
      <fund-submitted v-else-if="this.isSubmitted" />
      <fund-submitted-with-errors v-else-if="this.isSubmittedWithErrors" />
    </div>
  </div>
</template>

<script>
import TrackedPage from '@/mixins/TrackedPage';
import { mapActions, mapGetters, mapState } from 'vuex';
import ScrollToTop from '@/mixins/ScrollToTop';
import CombinedLogo from '@/components/meitav-dash/CombinedLogo';
import FundApproved from '@/components/meitav-dash/open-fund/FundApproved';
import FundSubmitted from '@/components/meitav-dash/open-fund/FundSubmitted';
import FundSubmittedWithErrors from '@/components/meitav-dash/open-fund/FundSubmittedWithErrors';
import GeneralErrorHandling from '@/mixins/GeneralErrorHandling';

export default {
  name: 'FundStatus',
  mixins: [TrackedPage, ScrollToTop, GeneralErrorHandling],
  components: {
    CombinedLogo,
    FundApproved,
    FundSubmitted,
    FundSubmittedWithErrors,
  },
  async created() {
    await this.initFundRequests();
    if (!this.isApproved && !this.isSubmitted && !this.isSubmittedWithErrors) {
      this.logErrorAndShowDialog(`Unknown fund status ${this.requestStatus}`);
    }
  },
  methods: {
    ...mapActions('meitavDash/fundRequests', ['initFundRequests']),
  },
  computed: {
    ...mapState('meitavDash/openFund', ['firstName']),
    ...mapState('meitavDash/fundRequests', ['requestStatus']),
    ...mapGetters('meitavDash/fundRequests', ['isCreated', 'isApproved', 'isSubmitted', 'isSubmittedWithErrors']),
  },
};
</script>

<style scoped lang="scss">
.header {
  margin-bottom: 80px;
}
</style>
